<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>{{title}}</h1>
    <div fxFlex.gt-sm="auto" class="scroll" fxLayout="column" fxLayoutAlign="start stretch">
        <div [innerHTML]="message | safeHTML"></div>
        <mat-form-field>
            <input
                matInput
                type="text"
                [(ngModel)]="ReferenceNumber"
                maxlength="15"
                [placeholder]="'Enter course' + (IsForAltReference ? ' alternative section' : '') + ' reference #'"
            />
        </mat-form-field>
        <mat-checkbox *ngIf="!IsForAltReference" [(ngModel)]="CountyTaught"
            >This course will be taught at a Polk County School District site location.</mat-checkbox
        >
        <div>{{ReferenceNumber}}</div>
    </div>
    <div
        class="actionbar"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="15px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start center"
    >
        <button mat-raised-button color="warn" (click)="CancelHandler()"><span [innerHTML]="canceltext | safeHTML"></span></button>
        <button
            mat-raised-button
            color="primary"
            (click)="OkHandler()"
            [disabled]="(!ReferenceNumber && !CountyTaught) || (IsForAltReference && !ReferenceNumber)"
        >
            <span
                [innerHTML]="oktext | safeHTML
        "
            ></span>
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/services/dialogs/schedulecourse/schedulecourse.dialogcomponent.html